import clsx from 'clsx';
import { type ForwardedRef, type MouseEvent, forwardRef } from 'react';
import type { Size } from './layout';

/**
 * List of icons: https://fonts.google.com/icons?icon.set=Material+Icons
 *
 * @example
 * <Icon size="sm" icon="home" outlined />
 */

export interface IconProps {
  icon: string;
  // color?: Color
  size?: Size;
  outlined?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

export const Icon = forwardRef((props: IconProps, ref: ForwardedRef<HTMLElement>) => {
  const { icon, size = 'md', outlined = false, className, onClick } = props;

  return (
    <i
      ref={ref}
      onClick={onClick}
      className={clsx([`icon icon-${size}`, className], {
        'icon-outlined': outlined,
      })}
    >
      {icon}
    </i>
  );
});
